import { render } from "./GridPositions.vue?vue&type=template&id=2278366c&ts=true"
import script from "./GridPositions.vue?vue&type=script&lang=ts"
export * from "./GridPositions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__